import { render } from "./TopMenuCard.vue?vue&type=template&id=38649dd2&scoped=true&ts=true"
import script from "./TopMenuCard.vue?vue&type=script&lang=ts"
export * from "./TopMenuCard.vue?vue&type=script&lang=ts"

import "./TopMenuCard.vue?vue&type=style&index=0&id=38649dd2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38649dd2"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection});
